export const turnedOffPrelandFromCloacka =
  "Прелендинг был успешно отключен от клоаки";
